/* tslint:disable */
/* eslint-disable */
/**
 * kms-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var Algorithm;
(function (Algorithm) {
    Algorithm["ed25519"] = "Ed25519";
    Algorithm["secp256r1"] = "Secp256r1";
    Algorithm["secp256k1"] = "Secp256k1";
    Algorithm["secp256k1Keccak256"] = "Secp256k1Keccak256";
    Algorithm["secp256k1Schnorr"] = "Secp256k1Schnorr";
})(Algorithm || (Algorithm = {}));
